export const exterior_view04ImageOptions = {
  angle: 'exterior_view04',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    TeakOnCoachroof: 1,
    SprayHood: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/XP55/views/exterior_view04.js